export { default as IntlService } from './services/intl-service';
export { default as TemplateService } from './services/template-service';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-ooxml/dist/es/services.js
// module id = 2692
// module chunks = 29